
import Clue from '../models/Clue'

const state = {
  clues: [],
  selected: {
    down: null,
    across: null,
  }
}

// TODO: it might be much more efficient to organise the clues by using their
// clue number as a key index 
const getters = {
  getClueByWord: state => word => {
    for (let i in state.clues) {
      let clue = state.clues[i]
      if (word === clue.solution)
        return clue
    }
    return false
  },

}

// { direction:string, clueNumber:number, clue:string }
const actions = {
  
  setClues({ commit, rootState, state }, clues) {

    commit('CLEAR_CLUES')

    clues.map(c => {

      let clue = new Clue()
      clue.direction = (Number(c.d) !== 0) ? 'down' : 'across'
      let across = clue.direction === 'across'
      clue.clueNumber = c.cn
      clue.clue = c.ct
      clue.solution = c.s
      let col = Number(c.c)
      let row = Number(c.r)

      // map cells in word
      clue.solution.split('').map(_ => {
        clue.cells.push(rootState.grid.cells[row][col])
        rootState.grid.cells[row][col].clues[clue.direction] = clue
        across ? col++ : row++
      })

      commit('PUSH_CLUE', clue)
    })

    state.clues.sort((a, b) => a.clueNumber - b.clueNumber)
  },

  selectCluesByCell({ commit }, cell) {
    commit('SELECT_CLUES_BY_CELL', cell)
  },

  highlightClueOnGrid({ dispatch }, clue) {
    let cell = dispatch('grid/selectCellByClueNumber', {
      clueNumber: clue.clueNumber,
      direction: clue.direction
    }, { root: true })
    .then(cell => {
      dispatch('selectCluesByCell', cell)
    })

  },

  // TODO: this is messy, should do a recursive method
  nextOrPrev_old({ state, rootState, dispatch }, prev = false) {
    let nextClue = null
    let clues = []
    let currClue = rootState.grid.isAcross ? 
      state.selected.across : 
      state.selected.down
    let firstOtherDirClue = null

    if (!currClue)
      return dispatch('highlightClueOnGrid', state.clues[0])

    state.clues.forEach(clue => {
      if (clue.direction === currClue.direction)
        clues.push(clue)
      else if (!prev && !firstOtherDirClue && clue.direction !== currClue.direction)
        firstOtherDirClue = clue
      else if (prev && clue.direction !== currClue.direction)
        firstOtherDirClue = clue
    })

    for (let i = 0; i < clues.length; i++) {
      let clue = clues[i]
      let nextIndex = null

      if (
        clue.direction === currClue.direction && 
        clue.clueNumber === currClue.clueNumber
      ) {
        nextIndex  = prev ? i-1 : i+1

        if (clues[nextIndex]) {
          nextClue = clues[nextIndex]
        }
        else {
          nextClue = firstOtherDirClue
        }
      }
    }

    dispatch('highlightClueOnGrid', nextClue)
  },

  nextOrPrev({ state, rootState, dispatch }, prev = false) {
   
    let currClue = rootState.grid.isAcross ? 
      state.selected.across : 
      state.selected.down

    if (!currClue)
      return dispatch('highlightClueOnGrid', state.clues[0])

    var currentClueNum = currClue.clueNumber == null ? 1 : currClue.clueNumber 

    let direction = currClue.direction

    const clueList = rootState.cluelist.clues;

    let nextClue = null

    if(!prev){
       nextClue = clueList.find((clue) => {
        return clue.direction == direction && clue.clueNumber > currentClueNum;
      });
    }
    else{
      // previous button clicked
      let nextClueArray = clueList.filter((clue) => {
        return clue.direction == direction && clue.clueNumber < currentClueNum;
      });
      nextClueArray.reverse()
      nextClue = nextClueArray[0]
    }


      if (nextClue) {
        let nC = nextClue.cells[0];
        let nCRow= nC.row
        let nCCol = nC.col
  
        let newClue = {
                clueNumber: nextClue.clueNumber,
                direction: direction
        }
        // we now have the co-ords of the next clue
        
        dispatch('highlightClueOnGrid', newClue)

        if(rootState.userSettings.crosswordJumpToBlank) // search for the next blank cell for this clue only (if one exists)
        {
          var continueLoop = true
            for(let i = 0; i < nextClue.cells.length; i++)
            {
              
              if(continueLoop)
              {
                  if(nextClue.cells[i].input == 0 )
                  {
                    let payload = {
                      row: nextClue.cells[i].row,
                      col: nextClue.cells[i].col
                    }
                    continueLoop = false
                    return dispatch('grid/selectCell', payload, {root: true})
                  }
              }
            }
        }
        else
        {
          return dispatch('grid/selectCell', {row: nCRow, col: nCCol}, {root: true})
        }
        
        
      }
      else
      {
          // Last clue has been reached - change to the other direction and go from the start again
          let switchDirection = rootState.grid.isAcross ? 'down' : 'across'

          nextClue = clueList.find((clue) => {
            return clue.direction == switchDirection && clue.clueNumber > 0;
          });

          let payload = {
            clueNumber: nextClue.clueNumber,
            direction: switchDirection
          }

          dispatch('highlightClueOnGrid', payload)

          // This code doesn't get hit too often but does when Jump mode is on and the first clue is selected after switch from across to down etc
          if(rootState.userSettings.crosswordJumpToBlank) // search for the next blank cell for this clue only (if one exists)
          {
            var continueLoop = true
              for(let i = 0; i < nextClue.cells.length; i++)
              {
                
                if(continueLoop)
                {
                    if(nextClue.cells[i].input == 0 )
                    {
                      let payload = {
                        row: nextClue.cells[i].row,
                        col: nextClue.cells[i].col
                      }
                      continueLoop = false
                      dispatch('grid/selectCell', payload, {root: true})
                    }
                }
              }
          }

      }

  },

  selectNextClue({ dispatch }) {
    dispatch('nextOrPrev', false)    
  },

  selectPrevClue({ dispatch }) {
    dispatch('nextOrPrev', true)    
  },
  
}



const mutations = {
  
  // cell model
  SELECT_CLUES_BY_CELL(state, cell) {
    state.selected.across = cell.clues.across
    state.selected.down = cell.clues.down
  },

  // clue model
  PUSH_CLUE(state, clue) {
    state.clues.push(clue)
  },

  CLEAR_CLUES(state) {
    state.clues = []
    state.selected.down = null;
    state.selected.across = null;
  },

}

export {
  state,
  getters,
  actions,
  mutations,
}